import { render, staticRenderFns } from "./SmallCards.vue?vue&type=template&id=1f391688&scoped=true&"
import script from "./SmallCards.vue?vue&type=script&lang=js&"
export * from "./SmallCards.vue?vue&type=script&lang=js&"
import style0 from "./SmallCards.vue?vue&type=style&index=0&id=1f391688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f391688",
  null
  
)

export default component.exports